module.exports = __webpack_public_path__ + "img/emails947.f01cd9af.svg";